//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class CourseService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCourses(courseStatus: CourseStatus | undefined, request: ListRequestOfCourseFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCourseModel> {
        let url_ = this.baseUrl + "/courses/all?";
        if (courseStatus === null)
            throw new globalThis.Error("The parameter 'courseStatus' cannot be null.");
        else if (courseStatus !== undefined)
            url_ += "courseStatus=" + encodeURIComponent("" + courseStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourses(_response);
        });
    }

    protected processGetCourses(response: AxiosResponse): Promise<ListResponseOfCourseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCourseModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCourseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCourseModel>(null as any);
    }

    getCourseHeader(skuId: string | undefined, cancelToken?: CancelToken): Promise<CourseHeaderResponse> {
        let url_ = this.baseUrl + "/courses/header?";
        if (skuId === null)
            throw new globalThis.Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "skuId=" + encodeURIComponent("" + skuId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseHeader(_response);
        });
    }

    protected processGetCourseHeader(response: AxiosResponse): Promise<CourseHeaderResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseHeaderResponse.fromJS(resultData200);
            return Promise.resolve<CourseHeaderResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseHeaderResponse>(null as any);
    }

    getCourseDetails(skuId: string | undefined, cancelToken?: CancelToken): Promise<CourseDetailsResponse> {
        let url_ = this.baseUrl + "/courses/details?";
        if (skuId === null)
            throw new globalThis.Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "skuId=" + encodeURIComponent("" + skuId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseDetails(_response);
        });
    }

    protected processGetCourseDetails(response: AxiosResponse): Promise<CourseDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourseDetailsResponse.fromJS(resultData200);
            return Promise.resolve<CourseDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourseDetailsResponse>(null as any);
    }

    getWebinarUrl(skuId: string, cancelToken?: CancelToken): Promise<WebinarUrlResponse> {
        let url_ = this.baseUrl + "/courses/{skuId}/webinar-url";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebinarUrl(_response);
        });
    }

    protected processGetWebinarUrl(response: AxiosResponse): Promise<WebinarUrlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WebinarUrlResponse.fromJS(resultData200);
            return Promise.resolve<WebinarUrlResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebinarUrlResponse>(null as any);
    }

    claimCredits(skuId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/courses/{skuId}/claim-credits";
        if (skuId === undefined || skuId === null)
            throw new globalThis.Error("The parameter 'skuId' must be defined.");
        url_ = url_.replace("{skuId}", encodeURIComponent("" + skuId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaimCredits(_response);
        });
    }

    protected processClaimCredits(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class DocumentService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCourseDocuments(courseStatus: CourseStatus | undefined, request: ListRequestOfCourseDocumentFilter | null | undefined, cancelToken?: CancelToken): Promise<ListResponseOfCourseDocumentModel> {
        let url_ = this.baseUrl + "/documents/all?";
        if (courseStatus === null)
            throw new globalThis.Error("The parameter 'courseStatus' cannot be null.");
        else if (courseStatus !== undefined)
            url_ += "courseStatus=" + encodeURIComponent("" + courseStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseDocuments(_response);
        });
    }

    protected processGetCourseDocuments(response: AxiosResponse): Promise<ListResponseOfCourseDocumentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCourseDocumentModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCourseDocumentModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCourseDocumentModel>(null as any);
    }
}

export class FacultyService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSummary( cancelToken?: CancelToken): Promise<FacultySummaryResponse> {
        let url_ = this.baseUrl + "/faculty/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<FacultySummaryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FacultySummaryResponse.fromJS(resultData200);
            return Promise.resolve<FacultySummaryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FacultySummaryResponse>(null as any);
    }
}

export class FacultyTypeService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFacultyTypes( cancelToken?: CancelToken): Promise<ResourceType[]> {
        let url_ = this.baseUrl + "/faculty-types/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFacultyTypes(_response);
        });
    }

    protected processGetFacultyTypes(response: AxiosResponse): Promise<ResourceType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ResourceType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceType[]>(null as any);
    }

    getResourceTypesByUser(courseStatus: CourseStatus | undefined, cancelToken?: CancelToken): Promise<ListResponseOfResourceType> {
        let url_ = this.baseUrl + "/faculty-types/by-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(courseStatus);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceTypesByUser(_response);
        });
    }

    protected processGetResourceTypesByUser(response: AxiosResponse): Promise<ListResponseOfResourceType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfResourceType.fromJS(resultData200);
            return Promise.resolve<ListResponseOfResourceType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfResourceType>(null as any);
    }
}

export class MenuService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLeftMenu( cancelToken?: CancelToken): Promise<Menu> {
        let url_ = this.baseUrl + "/menu/left";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeftMenu(_response);
        });
    }

    protected processGetLeftMenu(response: AxiosResponse): Promise<Menu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Menu.fromJS(resultData200);
            return Promise.resolve<Menu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Menu>(null as any);
    }

    getTopMenu( cancelToken?: CancelToken): Promise<Menu> {
        let url_ = this.baseUrl + "/menu/top";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopMenu(_response);
        });
    }

    protected processGetTopMenu(response: AxiosResponse): Promise<Menu> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Menu.fromJS(resultData200);
            return Promise.resolve<Menu>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Menu>(null as any);
    }
}

export class SettingService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSiteSettings( cancelToken?: CancelToken): Promise<SiteSettings> {
        let url_ = this.baseUrl + "/settings/site-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSiteSettings(_response);
        });
    }

    protected processGetSiteSettings(response: AxiosResponse): Promise<SiteSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteSettings.fromJS(resultData200);
            return Promise.resolve<SiteSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteSettings>(null as any);
    }
}

export class SkuUserAgreementService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSkuUserAgreement(skuUserAgreementId: string, cancelToken?: CancelToken): Promise<ResponseOfSkuUserAgreementInfoReview> {
        let url_ = this.baseUrl + "/sku-user-agreements/{skuUserAgreementId}";
        if (skuUserAgreementId === undefined || skuUserAgreementId === null)
            throw new globalThis.Error("The parameter 'skuUserAgreementId' must be defined.");
        url_ = url_.replace("{skuUserAgreementId}", encodeURIComponent("" + skuUserAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSkuUserAgreement(_response);
        });
    }

    protected processGetSkuUserAgreement(response: AxiosResponse): Promise<ResponseOfSkuUserAgreementInfoReview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfSkuUserAgreementInfoReview.fromJS(resultData200);
            return Promise.resolve<ResponseOfSkuUserAgreementInfoReview>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfSkuUserAgreementInfoReview>(null as any);
    }

    saveSkuUserAgreementReview(request: SkuUserAgreementInfoReviewRequest | null | undefined, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/sku-user-agreements/review";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSkuUserAgreementReview(_response);
        });
    }

    protected processSaveSkuUserAgreementReview(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    preview(skuUserAgreementPdfPreview: SkuUserAgreementPdfPreview | null | undefined, cancelToken?: CancelToken): Promise<ResponseOfString> {
        let url_ = this.baseUrl + "/sku-user-agreements/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skuUserAgreementPdfPreview);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<ResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfString.fromJS(resultData200);
            return Promise.resolve<ResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfString>(null as any);
    }
}

export class AuthenticationV2Service {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    loginComplete(sessionId: string | undefined, cancelToken?: CancelToken): Promise<ResponseOfAuthenticationResponse> {
        let url_ = this.baseUrl + "/authentication/v2/logincomplete?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginComplete(_response);
        });
    }

    protected processLoginComplete(response: AxiosResponse): Promise<ResponseOfAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAuthenticationResponse>(null as any);
    }

    getAuthenticationResponse( cancelToken?: CancelToken): Promise<ResponseOfAuthenticationResponse> {
        let url_ = this.baseUrl + "/authentication/v2/authentication-response";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthenticationResponse(_response);
        });
    }

    protected processGetAuthenticationResponse(response: AxiosResponse): Promise<ResponseOfAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfAuthenticationResponse.fromJS(resultData200);
            return Promise.resolve<ResponseOfAuthenticationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfAuthenticationResponse>(null as any);
    }

    stopImpersonating( cancelToken?: CancelToken): Promise<ResponseOfRedirectUrl> {
        let url_ = this.baseUrl + "/authentication/v2/stop-impersonating";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopImpersonating(_response);
        });
    }

    protected processStopImpersonating(response: AxiosResponse): Promise<ResponseOfRedirectUrl> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfRedirectUrl.fromJS(resultData200);
            return Promise.resolve<ResponseOfRedirectUrl>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfRedirectUrl>(null as any);
    }

    isAuthenticated( cancelToken?: CancelToken): Promise<ResponseOfBoolean> {
        let url_ = this.baseUrl + "/authentication/v2/is-authenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthenticated(_response);
        });
    }

    protected processIsAuthenticated(response: AxiosResponse): Promise<ResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<ResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResponseOfBoolean>(null as any);
    }

    getAuthData( cancelToken?: CancelToken): Promise<AuthData> {
        let url_ = this.baseUrl + "/authentication/v2/auth-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthData(_response);
        });
    }

    protected processGetAuthData(response: AxiosResponse): Promise<AuthData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthData.fromJS(resultData200);
            return Promise.resolve<AuthData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthData>(null as any);
    }

    switchApplication( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/authentication/v2/switch-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchApplication(_response);
        });
    }

    protected processSwitchApplication(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TelemetryService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getConnectionString( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/telemetry/connection-string";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectionString(_response);
        });
    }

    protected processGetConnectionString(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ResponseOfListOfCourseModelAndString implements IResponseOfListOfCourseModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: CourseModel[] | undefined;

    constructor(data?: IResponseOfListOfCourseModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CourseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCourseModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCourseModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCourseModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: CourseModel[] | undefined;
}

export class ResponseOfListOfCourseModel extends ResponseOfListOfCourseModelAndString implements IResponseOfListOfCourseModel {

    constructor(data?: IResponseOfListOfCourseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCourseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCourseModel extends IResponseOfListOfCourseModelAndString {
}

export class ListResponseOfCourseModel extends ResponseOfListOfCourseModel implements IListResponseOfCourseModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfCourseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCourseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCourseModel extends IResponseOfListOfCourseModel {
    totalRecords: number | undefined;
}

export enum ResponseCode {
    OK = "OK",
    UserDeleted = "UserDeleted",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    ValidationFailed = "ValidationFailed",
    NotFound = "NotFound",
    BusinessRuleFailed = "BusinessRuleFailed",
    AuthenticationExpired = "AuthenticationExpired",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    InternalServerError = "InternalServerError",
    ServiceUnavailable = "ServiceUnavailable",
}

export class CourseModel implements ICourseModel {
    id!: string;
    title!: string;
    format!: string;
    eventStartDate!: Date | undefined;
    eventEndDate!: Date | undefined;
    resources!: Resource[];
    type!: string;
    claimCreditState!: ClaimCreditState;
    isLive!: boolean;
    hasLiveEventDeliveryMethod!: boolean;
    deliveryMethodKey!: string | undefined;
    hasAgreement!: boolean;
    skuUserAgreementId!: string | undefined;

    constructor(data?: ICourseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.format = _data["format"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(Resource.fromJS(item));
            }
            this.type = _data["type"];
            this.claimCreditState = _data["claimCreditState"];
            this.isLive = _data["isLive"];
            this.hasLiveEventDeliveryMethod = _data["hasLiveEventDeliveryMethod"];
            this.deliveryMethodKey = _data["deliveryMethodKey"];
            this.hasAgreement = _data["hasAgreement"];
            this.skuUserAgreementId = _data["skuUserAgreementId"];
        }
    }

    static fromJS(data: any): CourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["format"] = this.format;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item ? item.toJSON() : undefined as any);
        }
        data["type"] = this.type;
        data["claimCreditState"] = this.claimCreditState;
        data["isLive"] = this.isLive;
        data["hasLiveEventDeliveryMethod"] = this.hasLiveEventDeliveryMethod;
        data["deliveryMethodKey"] = this.deliveryMethodKey;
        data["hasAgreement"] = this.hasAgreement;
        data["skuUserAgreementId"] = this.skuUserAgreementId;
        return data;
    }
}

export interface ICourseModel {
    id: string;
    title: string;
    format: string;
    eventStartDate: Date | undefined;
    eventEndDate: Date | undefined;
    resources: Resource[];
    type: string;
    claimCreditState: ClaimCreditState;
    isLive: boolean;
    hasLiveEventDeliveryMethod: boolean;
    deliveryMethodKey: string | undefined;
    hasAgreement: boolean;
    skuUserAgreementId: string | undefined;
}

export class BaseModel implements IBaseModel {
    id!: string;
    name!: string | undefined;
    value!: string | undefined;
    description!: string | undefined;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface IBaseModel {
    id: string;
    name: string | undefined;
    value: string | undefined;
    description: string | undefined;
}

export class Resource extends BaseModel implements IResource {
    summary!: string | undefined;
    bio!: string | undefined;
    typeName!: string | undefined;
    mediaLibraryItemId!: string | undefined;
    image!: string | undefined;
    sequence!: number;
    alternativeText!: string | undefined;
    organizationUserId!: string | undefined;

    constructor(data?: IResource) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summary = _data["summary"];
            this.bio = _data["bio"];
            this.typeName = _data["typeName"];
            this.mediaLibraryItemId = _data["mediaLibraryItemId"];
            this.image = _data["image"];
            this.sequence = _data["sequence"];
            this.alternativeText = _data["alternativeText"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static override fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        data["bio"] = this.bio;
        data["typeName"] = this.typeName;
        data["mediaLibraryItemId"] = this.mediaLibraryItemId;
        data["image"] = this.image;
        data["sequence"] = this.sequence;
        data["alternativeText"] = this.alternativeText;
        data["organizationUserId"] = this.organizationUserId;
        super.toJSON(data);
        return data;
    }
}

export interface IResource extends IBaseModel {
    summary: string | undefined;
    bio: string | undefined;
    typeName: string | undefined;
    mediaLibraryItemId: string | undefined;
    image: string | undefined;
    sequence: number;
    alternativeText: string | undefined;
    organizationUserId: string | undefined;
}

export enum ClaimCreditState {
    Claimed = "Claimed",
    Active = "Active",
    Disabled = "Disabled",
    Hidden = "Hidden",
}

export class ListRequestOfCourseFilter implements IListRequestOfCourseFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: CourseFilter | undefined;

    constructor(data?: IListRequestOfCourseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? CourseFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfCourseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfCourseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfCourseFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: CourseFilter | undefined;
}

export class BaseFilter implements IBaseFilter {
    searchText!: string | undefined;
    includedIds!: string[] | undefined;
    excludedIds!: string[] | undefined;

    constructor(data?: IBaseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["includedIds"])) {
                this.includedIds = [] as any;
                for (let item of _data["includedIds"])
                    this.includedIds!.push(item);
            }
            if (Array.isArray(_data["excludedIds"])) {
                this.excludedIds = [] as any;
                for (let item of _data["excludedIds"])
                    this.excludedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BaseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BaseFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        if (Array.isArray(this.includedIds)) {
            data["includedIds"] = [];
            for (let item of this.includedIds)
                data["includedIds"].push(item);
        }
        if (Array.isArray(this.excludedIds)) {
            data["excludedIds"] = [];
            for (let item of this.excludedIds)
                data["excludedIds"].push(item);
        }
        return data;
    }
}

export interface IBaseFilter {
    searchText: string | undefined;
    includedIds: string[] | undefined;
    excludedIds: string[] | undefined;
}

export class CourseFilter extends BaseFilter implements ICourseFilter {
    eventStartDate!: Date | undefined;
    eventEndDate!: Date | undefined;

    constructor(data?: ICourseFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): CourseFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CourseFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICourseFilter extends IBaseFilter {
    eventStartDate: Date | undefined;
    eventEndDate: Date | undefined;
}

export enum CourseStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class CourseHeaderResponse implements ICourseHeaderResponse {
    renderedTemplate!: string;

    constructor(data?: ICourseHeaderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renderedTemplate = _data["renderedTemplate"];
        }
    }

    static fromJS(data: any): CourseHeaderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CourseHeaderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renderedTemplate"] = this.renderedTemplate;
        return data;
    }
}

export interface ICourseHeaderResponse {
    renderedTemplate: string;
}

export class CourseDetailsResponse implements ICourseDetailsResponse {
    renderedTemplate!: string;
    model!: CourseModel;

    constructor(data?: ICourseDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renderedTemplate = _data["renderedTemplate"];
            this.model = _data["model"] ? CourseModel.fromJS(_data["model"]) : undefined as any;
        }
    }

    static fromJS(data: any): CourseDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renderedTemplate"] = this.renderedTemplate;
        data["model"] = this.model ? this.model.toJSON() : undefined as any;
        return data;
    }
}

export interface ICourseDetailsResponse {
    renderedTemplate: string;
    model: CourseModel;
}

export class WebinarUrlResponse implements IWebinarUrlResponse {
    url!: string;

    constructor(data?: IWebinarUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): WebinarUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IWebinarUrlResponse {
    url: string;
}

export class Response implements IResponse {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        return data;
    }
}

export interface IResponse {
    responseCode: ResponseCode;
    responseReason: string | undefined;
}

export class ResponseOfListOfCourseDocumentModelAndString implements IResponseOfListOfCourseDocumentModelAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: CourseDocumentModel[] | undefined;

    constructor(data?: IResponseOfListOfCourseDocumentModelAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CourseDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfCourseDocumentModelAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCourseDocumentModelAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfCourseDocumentModelAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: CourseDocumentModel[] | undefined;
}

export class ResponseOfListOfCourseDocumentModel extends ResponseOfListOfCourseDocumentModelAndString implements IResponseOfListOfCourseDocumentModel {

    constructor(data?: IResponseOfListOfCourseDocumentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfCourseDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfCourseDocumentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfCourseDocumentModel extends IResponseOfListOfCourseDocumentModelAndString {
}

export class ListResponseOfCourseDocumentModel extends ResponseOfListOfCourseDocumentModel implements IListResponseOfCourseDocumentModel {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfCourseDocumentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfCourseDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCourseDocumentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfCourseDocumentModel extends IResponseOfListOfCourseDocumentModel {
    totalRecords: number | undefined;
}

export class CourseDocumentModel implements ICourseDocumentModel {
    id!: string;
    title!: string;
    format!: string;
    eventStartDate!: Date | undefined;
    eventEndDate!: Date | undefined;
    resources!: Resource[];
    skuUserAgreementInfo!: SkuUserAgreementInfo;
    type!: string;

    constructor(data?: ICourseDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.format = _data["format"];
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(Resource.fromJS(item));
            }
            this.skuUserAgreementInfo = _data["skuUserAgreementInfo"] ? SkuUserAgreementInfo.fromJS(_data["skuUserAgreementInfo"]) : undefined as any;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CourseDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["format"] = this.format;
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item ? item.toJSON() : undefined as any);
        }
        data["skuUserAgreementInfo"] = this.skuUserAgreementInfo ? this.skuUserAgreementInfo.toJSON() : undefined as any;
        data["type"] = this.type;
        return data;
    }
}

export interface ICourseDocumentModel {
    id: string;
    title: string;
    format: string;
    eventStartDate: Date | undefined;
    eventEndDate: Date | undefined;
    resources: Resource[];
    skuUserAgreementInfo: SkuUserAgreementInfo;
    type: string;
}

export class SkuUserAgreementInfo implements ISkuUserAgreementInfo {
    id!: string;
    skuId!: string;
    organizationUserId!: string;
    sku!: string | undefined;
    skuTitle!: string | undefined;
    skuAvailabilityName!: string | undefined;
    userName!: string | undefined;
    resourceTypeNames!: string | undefined;
    agreementId!: string;
    agreementName!: string | undefined;
    dueDate!: Date;
    statusId!: string;
    statusName!: string | undefined;
    skuUserAgreementValues!: SkuUserAgreementValue[] | undefined;

    constructor(data?: ISkuUserAgreementInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.organizationUserId = _data["organizationUserId"];
            this.sku = _data["sku"];
            this.skuTitle = _data["skuTitle"];
            this.skuAvailabilityName = _data["skuAvailabilityName"];
            this.userName = _data["userName"];
            this.resourceTypeNames = _data["resourceTypeNames"];
            this.agreementId = _data["agreementId"];
            this.agreementName = _data["agreementName"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
            if (Array.isArray(_data["skuUserAgreementValues"])) {
                this.skuUserAgreementValues = [] as any;
                for (let item of _data["skuUserAgreementValues"])
                    this.skuUserAgreementValues!.push(SkuUserAgreementValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkuUserAgreementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["organizationUserId"] = this.organizationUserId;
        data["sku"] = this.sku;
        data["skuTitle"] = this.skuTitle;
        data["skuAvailabilityName"] = this.skuAvailabilityName;
        data["userName"] = this.userName;
        data["resourceTypeNames"] = this.resourceTypeNames;
        data["agreementId"] = this.agreementId;
        data["agreementName"] = this.agreementName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        if (Array.isArray(this.skuUserAgreementValues)) {
            data["skuUserAgreementValues"] = [];
            for (let item of this.skuUserAgreementValues)
                data["skuUserAgreementValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISkuUserAgreementInfo {
    id: string;
    skuId: string;
    organizationUserId: string;
    sku: string | undefined;
    skuTitle: string | undefined;
    skuAvailabilityName: string | undefined;
    userName: string | undefined;
    resourceTypeNames: string | undefined;
    agreementId: string;
    agreementName: string | undefined;
    dueDate: Date;
    statusId: string;
    statusName: string | undefined;
    skuUserAgreementValues: SkuUserAgreementValue[] | undefined;
}

export class SkuUserAgreementValue implements ISkuUserAgreementValue {
    id!: string | undefined;
    skuUserAgreementId!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    type!: string | undefined;

    constructor(data?: ISkuUserAgreementValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuUserAgreementId = _data["skuUserAgreementId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SkuUserAgreementValue {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuUserAgreementId"] = this.skuUserAgreementId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

export interface ISkuUserAgreementValue {
    id: string | undefined;
    skuUserAgreementId: string | undefined;
    name: string | undefined;
    value: string | undefined;
    type: string | undefined;
}

export class ListRequestOfCourseDocumentFilter implements IListRequestOfCourseDocumentFilter {
    pageNumber!: number | undefined;
    pageSize!: number | undefined;
    sortField!: string | undefined;
    sortDescending!: boolean;
    parameters!: CourseDocumentFilter | undefined;

    constructor(data?: IListRequestOfCourseDocumentFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.parameters = _data["parameters"] ? CourseDocumentFilter.fromJS(_data["parameters"]) : undefined as any;
        }
    }

    static fromJS(data: any): ListRequestOfCourseDocumentFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListRequestOfCourseDocumentFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : undefined as any;
        return data;
    }
}

export interface IListRequestOfCourseDocumentFilter {
    pageNumber: number | undefined;
    pageSize: number | undefined;
    sortField: string | undefined;
    sortDescending: boolean;
    parameters: CourseDocumentFilter | undefined;
}

export class CourseDocumentFilter extends BaseFilter implements ICourseDocumentFilter {
    resourceTypeIds!: string[] | undefined;
    eventStartDate!: Date | undefined;
    eventEndDate!: Date | undefined;
    onlyAttentionRequiredCourses!: boolean | undefined;

    constructor(data?: ICourseDocumentFilter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["resourceTypeIds"])) {
                this.resourceTypeIds = [] as any;
                for (let item of _data["resourceTypeIds"])
                    this.resourceTypeIds!.push(item);
            }
            this.eventStartDate = _data["eventStartDate"] ? new Date(_data["eventStartDate"].toString()) : undefined as any;
            this.eventEndDate = _data["eventEndDate"] ? new Date(_data["eventEndDate"].toString()) : undefined as any;
            this.onlyAttentionRequiredCourses = _data["onlyAttentionRequiredCourses"];
        }
    }

    static override fromJS(data: any): CourseDocumentFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDocumentFilter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resourceTypeIds)) {
            data["resourceTypeIds"] = [];
            for (let item of this.resourceTypeIds)
                data["resourceTypeIds"].push(item);
        }
        data["eventStartDate"] = this.eventStartDate ? this.eventStartDate.toISOString() : undefined as any;
        data["eventEndDate"] = this.eventEndDate ? this.eventEndDate.toISOString() : undefined as any;
        data["onlyAttentionRequiredCourses"] = this.onlyAttentionRequiredCourses;
        super.toJSON(data);
        return data;
    }
}

export interface ICourseDocumentFilter extends IBaseFilter {
    resourceTypeIds: string[] | undefined;
    eventStartDate: Date | undefined;
    eventEndDate: Date | undefined;
    onlyAttentionRequiredCourses: boolean | undefined;
}

export class FacultySummaryResponse implements IFacultySummaryResponse {
    renderedTemplate!: string;

    constructor(data?: IFacultySummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renderedTemplate = _data["renderedTemplate"];
        }
    }

    static fromJS(data: any): FacultySummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FacultySummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renderedTemplate"] = this.renderedTemplate;
        return data;
    }
}

export interface IFacultySummaryResponse {
    renderedTemplate: string;
}

export class ResourceType implements IResourceType {
    id!: string;
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: IResourceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ResourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IResourceType {
    id: string;
    name: string | undefined;
    value: string | undefined;
}

export class ResponseOfListOfResourceTypeAndString implements IResponseOfListOfResourceTypeAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: ResourceType[] | undefined;

    constructor(data?: IResponseOfListOfResourceTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ResourceType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseOfListOfResourceTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResponseOfListOfResourceTypeAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: ResourceType[] | undefined;
}

export class ResponseOfListOfResourceType extends ResponseOfListOfResourceTypeAndString implements IResponseOfListOfResourceType {

    constructor(data?: IResponseOfListOfResourceType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfListOfResourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfListOfResourceType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfListOfResourceType extends IResponseOfListOfResourceTypeAndString {
}

export class ListResponseOfResourceType extends ResponseOfListOfResourceType implements IListResponseOfResourceType {
    totalRecords!: number | undefined;

    constructor(data?: IListResponseOfResourceType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalRecords = _data["totalRecords"];
        }
    }

    static override fromJS(data: any): ListResponseOfResourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfResourceType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        super.toJSON(data);
        return data;
    }
}

export interface IListResponseOfResourceType extends IResponseOfListOfResourceType {
    totalRecords: number | undefined;
}

export class Menu implements IMenu {
    menuItems!: MenuItem[];
    userInfo!: MenuUserInfo;

    constructor(data?: IMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItem.fromJS(item));
            }
            this.userInfo = _data["userInfo"] ? MenuUserInfo.fromJS(_data["userInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): Menu {
        data = typeof data === 'object' ? data : {};
        let result = new Menu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IMenu {
    menuItems: MenuItem[];
    userInfo: MenuUserInfo;
}

export class MenuItem implements IMenuItem {
    name!: string;
    toolTip!: string | undefined;
    url!: string;
    icon!: string;
    id!: string;
    parentId!: string | undefined;

    constructor(data?: IMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.toolTip = _data["toolTip"];
            this.url = _data["url"];
            this.icon = _data["icon"];
            this.id = _data["id"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): MenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["toolTip"] = this.toolTip;
        data["url"] = this.url;
        data["icon"] = this.icon;
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IMenuItem {
    name: string;
    toolTip: string | undefined;
    url: string;
    icon: string;
    id: string;
    parentId: string | undefined;
}

export class MenuUserInfo implements IMenuUserInfo {
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string;
    isImpersonation!: boolean;

    constructor(data?: IMenuUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.isImpersonation = _data["isImpersonation"];
        }
    }

    static fromJS(data: any): MenuUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MenuUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isImpersonation"] = this.isImpersonation;
        return data;
    }
}

export interface IMenuUserInfo {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string;
    isImpersonation: boolean;
}

export class SiteSettings implements ISiteSettings {
    theme!: SiteTheme;

    constructor(data?: ISiteSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"] ? SiteTheme.fromJS(_data["theme"]) : undefined as any;
        }
    }

    static fromJS(data: any): SiteSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SiteSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme ? this.theme.toJSON() : undefined as any;
        return data;
    }
}

export interface ISiteSettings {
    theme: SiteTheme;
}

export class SiteTheme implements ISiteTheme {
    primaryColor!: ColorVariants | undefined;
    secondaryColor!: ColorVariants | undefined;
    tertiaryColor!: ColorVariants | undefined;
    backgroundColor!: ColorVariants | undefined;
    greenColor!: ColorVariants | undefined;
    redColor!: ColorVariants | undefined;
    grayColor!: ColorVariants | undefined;
    faviconUrl!: string | undefined;
    logoUrl!: string | undefined;
    logoAlternativeText!: string | undefined;
    externalHostUrl!: string | undefined;
    baseCssUrl!: string | undefined;

    constructor(data?: ISiteTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["primaryColor"] ? ColorVariants.fromJS(_data["primaryColor"]) : undefined as any;
            this.secondaryColor = _data["secondaryColor"] ? ColorVariants.fromJS(_data["secondaryColor"]) : undefined as any;
            this.tertiaryColor = _data["tertiaryColor"] ? ColorVariants.fromJS(_data["tertiaryColor"]) : undefined as any;
            this.backgroundColor = _data["backgroundColor"] ? ColorVariants.fromJS(_data["backgroundColor"]) : undefined as any;
            this.greenColor = _data["greenColor"] ? ColorVariants.fromJS(_data["greenColor"]) : undefined as any;
            this.redColor = _data["redColor"] ? ColorVariants.fromJS(_data["redColor"]) : undefined as any;
            this.grayColor = _data["grayColor"] ? ColorVariants.fromJS(_data["grayColor"]) : undefined as any;
            this.faviconUrl = _data["faviconUrl"];
            this.logoUrl = _data["logoUrl"];
            this.logoAlternativeText = _data["logoAlternativeText"];
            this.externalHostUrl = _data["externalHostUrl"];
            this.baseCssUrl = _data["baseCssUrl"];
        }
    }

    static fromJS(data: any): SiteTheme {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryColor"] = this.primaryColor ? this.primaryColor.toJSON() : undefined as any;
        data["secondaryColor"] = this.secondaryColor ? this.secondaryColor.toJSON() : undefined as any;
        data["tertiaryColor"] = this.tertiaryColor ? this.tertiaryColor.toJSON() : undefined as any;
        data["backgroundColor"] = this.backgroundColor ? this.backgroundColor.toJSON() : undefined as any;
        data["greenColor"] = this.greenColor ? this.greenColor.toJSON() : undefined as any;
        data["redColor"] = this.redColor ? this.redColor.toJSON() : undefined as any;
        data["grayColor"] = this.grayColor ? this.grayColor.toJSON() : undefined as any;
        data["faviconUrl"] = this.faviconUrl;
        data["logoUrl"] = this.logoUrl;
        data["logoAlternativeText"] = this.logoAlternativeText;
        data["externalHostUrl"] = this.externalHostUrl;
        data["baseCssUrl"] = this.baseCssUrl;
        return data;
    }
}

export interface ISiteTheme {
    primaryColor: ColorVariants | undefined;
    secondaryColor: ColorVariants | undefined;
    tertiaryColor: ColorVariants | undefined;
    backgroundColor: ColorVariants | undefined;
    greenColor: ColorVariants | undefined;
    redColor: ColorVariants | undefined;
    grayColor: ColorVariants | undefined;
    faviconUrl: string | undefined;
    logoUrl: string | undefined;
    logoAlternativeText: string | undefined;
    externalHostUrl: string | undefined;
    baseCssUrl: string | undefined;
}

export class ColorVariants implements IColorVariants {
    base!: string | undefined;
    light!: string | undefined;
    pale!: string | undefined;
    lighter!: string | undefined;
    lightPale!: string | undefined;
    ultraLight!: string | undefined;
    dark!: string | undefined;

    constructor(data?: IColorVariants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base = _data["base"];
            this.light = _data["light"];
            this.pale = _data["pale"];
            this.lighter = _data["lighter"];
            this.lightPale = _data["lightPale"];
            this.ultraLight = _data["ultraLight"];
            this.dark = _data["dark"];
        }
    }

    static fromJS(data: any): ColorVariants {
        data = typeof data === 'object' ? data : {};
        let result = new ColorVariants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base"] = this.base;
        data["light"] = this.light;
        data["pale"] = this.pale;
        data["lighter"] = this.lighter;
        data["lightPale"] = this.lightPale;
        data["ultraLight"] = this.ultraLight;
        data["dark"] = this.dark;
        return data;
    }
}

export interface IColorVariants {
    base: string | undefined;
    light: string | undefined;
    pale: string | undefined;
    lighter: string | undefined;
    lightPale: string | undefined;
    ultraLight: string | undefined;
    dark: string | undefined;
}

export class ResponseOfSkuUserAgreementInfoReviewAndString implements IResponseOfSkuUserAgreementInfoReviewAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: SkuUserAgreementInfoReview | undefined;

    constructor(data?: IResponseOfSkuUserAgreementInfoReviewAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? SkuUserAgreementInfoReview.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfSkuUserAgreementInfoReviewAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuUserAgreementInfoReviewAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfSkuUserAgreementInfoReviewAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: SkuUserAgreementInfoReview | undefined;
}

export class ResponseOfSkuUserAgreementInfoReview extends ResponseOfSkuUserAgreementInfoReviewAndString implements IResponseOfSkuUserAgreementInfoReview {

    constructor(data?: IResponseOfSkuUserAgreementInfoReview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfSkuUserAgreementInfoReview {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfSkuUserAgreementInfoReview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfSkuUserAgreementInfoReview extends IResponseOfSkuUserAgreementInfoReviewAndString {
}

export class SkuUserAgreementInfoReview implements ISkuUserAgreementInfoReview {
    id!: string;
    skuId!: string;
    agreementId!: string;
    statusId!: string;
    organizationUserId!: string;
    contactTooltip!: string | undefined;

    constructor(data?: ISkuUserAgreementInfoReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skuId = _data["skuId"];
            this.agreementId = _data["agreementId"];
            this.statusId = _data["statusId"];
            this.organizationUserId = _data["organizationUserId"];
            this.contactTooltip = _data["contactTooltip"];
        }
    }

    static fromJS(data: any): SkuUserAgreementInfoReview {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementInfoReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skuId"] = this.skuId;
        data["agreementId"] = this.agreementId;
        data["statusId"] = this.statusId;
        data["organizationUserId"] = this.organizationUserId;
        data["contactTooltip"] = this.contactTooltip;
        return data;
    }
}

export interface ISkuUserAgreementInfoReview {
    id: string;
    skuId: string;
    agreementId: string;
    statusId: string;
    organizationUserId: string;
    contactTooltip: string | undefined;
}

export class SkuUserAgreementInfoReviewRequest implements ISkuUserAgreementInfoReviewRequest {
    id!: string | undefined;
    statusId!: string;

    constructor(data?: ISkuUserAgreementInfoReviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): SkuUserAgreementInfoReviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementInfoReviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ISkuUserAgreementInfoReviewRequest {
    id: string | undefined;
    statusId: string;
}

export class ResponseOfStringAndString implements IResponseOfStringAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: string | undefined;

    constructor(data?: IResponseOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfStringAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: string | undefined;
}

export class ResponseOfString extends ResponseOfStringAndString implements IResponseOfString {

    constructor(data?: IResponseOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfString extends IResponseOfStringAndString {
}

export class SkuUserAgreementPdfPreview implements ISkuUserAgreementPdfPreview {
    fileId!: string;
    organizationUserId!: string;

    constructor(data?: ISkuUserAgreementPdfPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.organizationUserId = _data["organizationUserId"];
        }
    }

    static fromJS(data: any): SkuUserAgreementPdfPreview {
        data = typeof data === 'object' ? data : {};
        let result = new SkuUserAgreementPdfPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["organizationUserId"] = this.organizationUserId;
        return data;
    }
}

export interface ISkuUserAgreementPdfPreview {
    fileId: string;
    organizationUserId: string;
}

export class ResponseOfAuthenticationResponseAndString implements IResponseOfAuthenticationResponseAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: AuthenticationResponse | undefined;

    constructor(data?: IResponseOfAuthenticationResponseAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? AuthenticationResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfAuthenticationResponseAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthenticationResponseAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfAuthenticationResponseAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: AuthenticationResponse | undefined;
}

export class ResponseOfAuthenticationResponse extends ResponseOfAuthenticationResponseAndString implements IResponseOfAuthenticationResponse {

    constructor(data?: IResponseOfAuthenticationResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfAuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfAuthenticationResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfAuthenticationResponse extends IResponseOfAuthenticationResponseAndString {
}

export class AuthenticationResponse implements IAuthenticationResponse {
    result!: boolean;
    id!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    organizationId!: string | undefined;
    returnUrl!: string | undefined;
    permissions!: string[] | undefined;
    impersonatedUserEmail!: string | undefined;
    impersonatingOrganizationUserId!: string | undefined;

    constructor(data?: IAuthenticationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.organizationId = _data["organizationId"];
            this.returnUrl = _data["returnUrl"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.impersonatedUserEmail = _data["impersonatedUserEmail"];
            this.impersonatingOrganizationUserId = _data["impersonatingOrganizationUserId"];
        }
    }

    static fromJS(data: any): AuthenticationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["organizationId"] = this.organizationId;
        data["returnUrl"] = this.returnUrl;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["impersonatedUserEmail"] = this.impersonatedUserEmail;
        data["impersonatingOrganizationUserId"] = this.impersonatingOrganizationUserId;
        return data;
    }
}

export interface IAuthenticationResponse {
    result: boolean;
    id: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    organizationId: string | undefined;
    returnUrl: string | undefined;
    permissions: string[] | undefined;
    impersonatedUserEmail: string | undefined;
    impersonatingOrganizationUserId: string | undefined;
}

export class ResponseOfRedirectUrlAndString implements IResponseOfRedirectUrlAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: RedirectUrl | undefined;

    constructor(data?: IResponseOfRedirectUrlAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"] ? RedirectUrl.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseOfRedirectUrlAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRedirectUrlAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IResponseOfRedirectUrlAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: RedirectUrl | undefined;
}

export class ResponseOfRedirectUrl extends ResponseOfRedirectUrlAndString implements IResponseOfRedirectUrl {

    constructor(data?: IResponseOfRedirectUrl) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfRedirectUrl {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfRedirectUrl();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfRedirectUrl extends IResponseOfRedirectUrlAndString {
}

export class RedirectUrl implements IRedirectUrl {
    url!: string | undefined;

    constructor(data?: IRedirectUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): RedirectUrl {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IRedirectUrl {
    url: string | undefined;
}

export class ResponseOfBooleanAndString implements IResponseOfBooleanAndString {
    responseCode!: ResponseCode;
    responseReason!: string | undefined;
    data!: boolean;

    constructor(data?: IResponseOfBooleanAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"];
            this.responseReason = _data["responseReason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResponseOfBooleanAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBooleanAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        data["responseReason"] = this.responseReason;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseOfBooleanAndString {
    responseCode: ResponseCode;
    responseReason: string | undefined;
    data: boolean;
}

export class ResponseOfBoolean extends ResponseOfBooleanAndString implements IResponseOfBoolean {

    constructor(data?: IResponseOfBoolean) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOfBoolean();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResponseOfBoolean extends IResponseOfBooleanAndString {
}

export class AuthData implements IAuthData {
    applicationId!: string;
    organizationId!: string;
    userId!: string | undefined;
    isImpersonating!: boolean;
    stopImpersonationUrl!: string | undefined;

    constructor(data?: IAuthData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.organizationId = _data["organizationId"];
            this.userId = _data["userId"];
            this.isImpersonating = _data["isImpersonating"];
            this.stopImpersonationUrl = _data["stopImpersonationUrl"];
        }
    }

    static fromJS(data: any): AuthData {
        data = typeof data === 'object' ? data : {};
        let result = new AuthData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["organizationId"] = this.organizationId;
        data["userId"] = this.userId;
        data["isImpersonating"] = this.isImpersonating;
        data["stopImpersonationUrl"] = this.stopImpersonationUrl;
        return data;
    }
}

export interface IAuthData {
    applicationId: string;
    organizationId: string;
    userId: string | undefined;
    isImpersonating: boolean;
    stopImpersonationUrl: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}